import * as CONST from "../src/constants/urlConstants";

var domainSplitResult  =  window.location.hostname.split('.');
domainSplitResult[0] = '';
var subDomain = domainSplitResult.join('.');

let ssoPrefix = 'sso';
let portalPrefix = 'service';
let consolePrefix = 'console';

switch (subDomain) {
    case CONST.DOOSAN:
        ssoPrefix    = CONST.DOOSAN_SSO;
        portalPrefix = CONST.DOOSAN_PORTAL;
        consolePrefix = 'consolemp';
        break;
    case CONST.HYUNDAIMOVEX:
        ssoPrefix    = CONST.HYUNDAIMOVEX_SSO;
        portalPrefix = CONST.HYUNDAIMOVEX_PORTAL;
        break;
    case CONST.SCK:
        portalPrefix = CONST.SCK_PORTAL;
        break;
    case CONST.COMTEC:
        portalPrefix = CONST.COMTEC_PORTAL;
        break;
    case CONST.WINS21:
        portalPrefix = CONST.WINS21_PORTAL;
        break;
    case CONST.HYUNDAI_AUTOEVER:
    case CONST.HYUNDAI_AUTOEVER_NEW:
        ssoPrefix    = CONST.HYUNDAI_AUTOEVER_SSO;
        portalPrefix = CONST.HYUNDAI_AUTOEVER_PORTAL;
        consolePrefix = 'console-cmp'
        break;
    default:
}

let ssoUrl = ''
let govUrl = window.location.protocol + '//' + window.location.host
let portalUrl = ''
let supportUrl = ''
let supportLegacyUrl = ''
let srUrl = ''
let brandUrl = ''
let consoleUrl = ''
let apiGwUrl = ''

switch(process.env.ENV) {
    case 'prd':
        ssoUrl = "https://" + ssoPrefix + subDomain;
        govUrl = window.location.protocol + "//" + window.location.host;
        portalUrl = "https://" + portalPrefix + subDomain;
        supportUrl = "https://support.opsnow.com/customer/login";
        supportLegacyUrl = "https://support.bespinglobal.com/login";
        srUrl = "https://support.opsnow.com/customer/login";
        brandUrl = "https://www.opsnow.com";
        consoleUrl = "https://" + consolePrefix + subDomain;
        apiGwUrl = "https://api.opsnow.com"
        break;
    case 'gstg':
        ssoUrl = "https://" + ssoPrefix + subDomain;
        govUrl = window.location.protocol + "//" + window.location.host;
        portalUrl = "https://" + portalPrefix + subDomain;
        supportUrl = "https://support.opsnow.com/customer/login";
        supportLegacyUrl = "https://support.bespinglobal.com/login";
        srUrl = "https://support.opsnow.com/customer/login";
        brandUrl = "https://www.gstg.opsnow.com";
        consoleUrl = "https://" + consolePrefix + subDomain;
        apiGwUrl = "https://api.gstg.opsnow.com"
        break;
    case 'mea':
        ssoUrl = "https://" + ssoPrefix + subDomain;
        govUrl = window.location.protocol + "//" + window.location.host;
        portalUrl = "https://" + portalPrefix + subDomain;
        supportUrl = "https://support.opsnow.com/customer/login";
        supportLegacyUrl = "https://support.bespinglobal.com/login";
        srUrl = "https://support.opsnow.com/customer/login";
        brandUrl = "https://" + portalPrefix + subDomain;
        consoleUrl = "https://" + consolePrefix + subDomain;
        apiGwUrl = "https://api.opsnow.me"
        break;
    case 'hcmp':
        ssoUrl = "https://" + ssoPrefix + subDomain;
        govUrl = window.location.protocol + "//" + window.location.host;
        portalUrl = "https://" + portalPrefix + subDomain;
        supportUrl = "https://support.opsnow.com/customer/login";
        supportLegacyUrl = "https://support.bespinglobal.com/login";
        srUrl = "https://support.opsnow.com/customer/login";
        brandUrl = "https://" + portalPrefix + subDomain;
        consoleUrl = "https://" + consolePrefix + subDomain;
        apiGwUrl = "https://api.cmp.honecloud.co.kr"
        break;
    case 'usa':
        ssoUrl = "https://" + ssoPrefix + subDomain;
        govUrl = window.location.protocol + "//" + window.location.host;
        portalUrl = "https://" + portalPrefix + subDomain;
        supportUrl = "https://support.opsnow.com/customer/login";
        supportLegacyUrl = "https://support.bespinglobal.com/login";
        srUrl = "https://support.opsnow.com/customer/login";
        brandUrl = "https://" + portalPrefix + subDomain;
        consoleUrl = "https://" + consolePrefix + subDomain;
        apiGwUrl = "https://api.opsnow.us"
        break;
    case 'kecmp':
        ssoUrl = "https://" + ssoPrefix + subDomain;
        govUrl = window.location.protocol + "//" + window.location.host;
        portalUrl = "https://" + portalPrefix + subDomain;
        supportUrl = "https://support.opsnow.com/customer/login";
        supportLegacyUrl = "https://support.bespinglobal.com/login";
        srUrl = "https://support.opsnow.com/customer/login";
        brandUrl = "https://" + portalPrefix + subDomain;
        consoleUrl = "https://" + consolePrefix + subDomain;
        apiGwUrl = "https://api.kakaocmp.com"
        break;
    case 'dev':
        ssoUrl = "https://ssodev" + subDomain;
        govUrl = window.location.protocol + "//" + window.location.host;
        portalUrl = "https://servicedev" + subDomain;
        supportUrl = "https://support.opsnow.com/customer/login";
        supportLegacyUrl = "https://support.bespinglobal.com/login";
        srUrl = "https://support.opsnow.com/customer/login";
        brandUrl = "https://ocp-opsnow-brand-site-sandbox.dev.opsnow.com";
        consoleUrl = "https://consoledev" + subDomain;
        apiGwUrl = "https://apidev.opsnow.com"
        break;
}

export default {
    ssoUrl : ssoUrl,
    govUrl : govUrl,
    portalUrl : portalUrl,
    supportUrl : supportUrl,
    supportLegacyUrl : supportLegacyUrl,
    srUrl : srUrl,
    brandUrl : brandUrl,
    consoleUrl : consoleUrl,
    apiGwUrl : apiGwUrl,
}



//////////////////
// WEBPACK FOOTER
// ./config/urls.conf.js
// module id = null
// module chunks = 